import useAccountFeatureConfigs from '@/shared/providers/useAccountFeatureConfigs';
import { useToken } from '@/utils/token';

// Disable automations and exclude future invoices for was smb accounts if not impersonated session
const useEnableAutomations = (): boolean => {
  const { isImpersonationSession } = useToken();
  const { wasSmbMigrated } = useAccountFeatureConfigs();

  return isImpersonationSession || !wasSmbMigrated;
};

export default useEnableAutomations;
